import calculatePpf from 'helpers/calculations/calculatePpf'
import calculateAspectRatio from 'helpers/calculations/calculateAspectRatio'
import parseResolutions from 'helpers/parseResolutions'
import calculateVerticalFieldOfView from 'helpers/calculations/calculateVerticalFieldOfView'
import calculateVerticalAngleOfView from 'helpers/calculations/calculateVerticalAngleOfView'
import calculateHorizontalAngleOfView from 'helpers/calculations/calculateHorizontalAngleOfView'
import calculateHorizontalFieldOfViewFromVerticalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfViewFromVerticalFieldOfView'

import { CONVENTIONAL } from 'helpers/globals'

/**
 * Parses a string for horizontal and vertical resolutions then calculates
 * their dependant ppf.
 * @param {Object} camera - The current camera being updated.
 * @param {String} resolution - The resolutions in `'2688 x 1520'` form.
 * @return {Object} The camera passsed in with updated attributes.
*/

export default function updateResolutions(camera, resolution) {
  const resolutions = parseResolutions(resolution)
  const { distance, horizontalFieldOfView, fovMode, horizontalAngleOfView, verticalFieldOfView, model } = camera

  const aspectRatio = calculateAspectRatio({
    horizontalResolution: resolutions.horizontal,
    verticalResolution: resolutions.vertical
  })

  if (fovMode === CONVENTIONAL) {
    return Object.assign({}, camera, {
      horizontalResolution: resolutions.horizontal,
      verticalResolution: resolutions.vertical,
      ppf: calculatePpf({ horizontalResolution: resolutions.horizontal, horizontalFieldOfView, model, distance }),
      aspectRatio,
      verticalFieldOfView: calculateVerticalFieldOfView({ aspectRatio, horizontalFieldOfView }),
      verticalAngleOfView: calculateVerticalAngleOfView({ aspectRatio, horizontalAngleOfView })
    })
  } else {
    const horizontalFieldOfView = calculateHorizontalFieldOfViewFromVerticalFieldOfView({ aspectRatio, verticalFieldOfView })
    return Object.assign({}, camera, {
      horizontalResolution: resolutions.horizontal,
      verticalResolution: resolutions.vertical,
      ppf: calculatePpf({ horizontalResolution: resolutions.vertical, horizontalFieldOfView: verticalFieldOfView }),
      aspectRatio,
      horizontalAngleOfView: calculateHorizontalAngleOfView({ distance, horizontalFieldOfView }),
      horizontalFieldOfView
    })
  }
}



// WEBPACK FOOTER //
// ./src/reducers/updateResolutions.js